import axios from '../plugins/axios'

const API_URL = process.env.VUE_APP_API_URL + '/gpsdevices/'
class GPSDevicesAPI {
  list() {
    return axios
      .get(API_URL)
      .then(response => {
        return response.data
      })
  }
  show(id) {
    return axios
      .get(API_URL + id)
      .then(response => {
        return response.data
      })
  }
  edit(id, data) {
    return axios
      .put(API_URL + id, {
        deviceId: data.deviceId,
        name: data.name,
        motorbike: data.motorbike,
        autoAssignMotorbike: data.autoAssignMotorbike
      })
      .then(response => {
        return response.data
      })
  }
  create(data) {
    return axios
      .post(API_URL, {
        deviceId: data.deviceId,
        name: data.name,
        motorbike: data.motorbike,
        autoAssignMotorbike: data.autoAssignMotorbike
      })
      .then(response => {
        return response.data
      })
  }
  delete(id) {
    return axios
      .delete(API_URL + id)
      .then(response => {
        return response.data
      })
  }
}
export default new GPSDevicesAPI()